import find from 'lodash/find'
import dayjs from 'dayjs'
import numbro from 'numbro'
import { deserializePage as deserialize } from 'supporticon/api/pages'
import { convertMetersToUnit } from 'supporticon/utils/units'
import { stripTags } from 'supporticon/utils/html'

const hasUpdatedStory = (defaultStory, story) =>
  !!defaultStory && stripTags(story) !== stripTags(defaultStory)

// Reducer
export const deserializePage = (page, uom) => {
  const deserializedPage = deserialize(page)
  const goalTag = find(deserializedPage.tags, tag =>
    tag.tagDefinition.id === 'DSFitnessGoalTargetMeters'
  )
  const fitnessGoal = parseFloat(
    goalTag
      ? numbro(convertMetersToUnit(goalTag.value, uom)).format('0[.][0]')
      : page.pageSummaryWhat
  )

  return {
    ...deserializedPage,
    hasUpdatedStory: hasUpdatedStory(page.defaultPageStory, deserializedPage.story),
    hasSetFitnessGoal: !isNaN(fitnessGoal) && fitnessGoal > 0,
    url: `/fundraising/${deserializedPage.slug}`,
    adminUrl: deserializedPage.url.replace('/fundraising/', '/fundraising-edit/'),
    formattedCampaignDate: deserializedPage.campaignDate &&
      dayjs(deserializedPage.campaignDate).format('MMMM Do YYYY'),
    fitnessGoal
  }
}

export default deserializePage
